import { NoResultsOverlay } from '@components/dataGrid/common/NoResultsOverlay';
import { TFilterValues } from '@components/table/types';

export type NoResultsConfig = {
  disableNoMatchFound?: boolean;
  noResultsMessage?: string;
  noFilteredResultsMessage?: string;
  noResultsTitle?: string;
  noMatchButtonText?: string;
  ComponentOverride?:
    | React.ReactNode
    | ((props: NoResultsOverlaySlotProps & { appliedFilters: boolean }) => React.ReactNode);
  ignoreFilters?: string[];
};

export type NoResultsOverlaySlotProps = {
  filterValues: TFilterValues;
  isLoading: boolean;
  onClearAllFilters: () => void;
};

export const NoResultsOverlaySlot = ({
  filterValues,
  isLoading,
  noMatchButtonText,
  noResultsMessage,
  disableNoMatchFound,
  noFilteredResultsMessage,
  noResultsTitle,
  onClearAllFilters,
  ComponentOverride,
  ignoreFilters,
}: NoResultsOverlaySlotProps & NoResultsConfig) => {
  const appliedFiltersWithoutIgnored = Object.keys(filterValues).reduce((acc, key) => {
    if (!ignoreFilters || !ignoreFilters.includes(key)) {
      acc[key] = filterValues[key];
    }
    return acc;
  }, {} as TFilterValues);

  const appliedFilters = Object.keys(appliedFiltersWithoutIgnored)?.length > 0;

  if (ComponentOverride) {
    return typeof ComponentOverride === 'function'
      ? ComponentOverride({ appliedFilters, filterValues, isLoading, onClearAllFilters })
      : ComponentOverride;
  }

  if (!disableNoMatchFound && appliedFilters && !isLoading) {
    return (
      <NoResultsOverlay
        noResultsMsg={{
          title: noResultsTitle ?? '',
          subtitle: noFilteredResultsMessage ?? "There aren't any results that match your criteria",
        }}
        onViewAllClick={onClearAllFilters}
        buttonText={noMatchButtonText}
      />
    );
  }

  return (
    <NoResultsOverlay noResultsMsg={{ subtitle: noResultsMessage ?? 'There are currently no items to display' }} />
  );
};
